import script from "./ClientsPanelFilters.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClientsPanelFilters.vue?vue&type=script&setup=true&lang=ts"

import "./ClientsPanelFilters.vue?vue&type=style&index=0&id=07ad2ad7&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07ad2ad7"]])

export default __exports__
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QField});
